import { render, staticRenderFns } from "./ButtonLiveChat.vue?vue&type=template&id=66d1385c&scoped=true"
import script from "./ButtonLiveChat.vue?vue&type=script&lang=js"
export * from "./ButtonLiveChat.vue?vue&type=script&lang=js"
import style0 from "./ButtonLiveChat.vue?vue&type=style&index=0&id=66d1385c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d1385c",
  null
  
)

export default component.exports